/**
 * Docket entry Automated Text
 */
import { axiosRequest } from '@/plugins/axios-common'
import { dateDisplayFormat } from '@/utilities'
import { handleError } from '@/store/handle-error'

const automatedTextPreferredRecipient = phones => {
  let recipients = []
  const preferredPhones = phones.filter(phone => phone.preferred_text)
  if (preferredPhones.length > 0) recipients = preferredPhones
  else recipients = phones

  return recipients.map(phone => phone.phone_number).join(', ')
}

const automatedTextSendAt = (docketEntry, template) => {
  const interval = template ? template.automated_text_interval : 0
  const unit = template ? template.automated_text_interval_unit : undefined

  const intervalOccurence = interval > 0 ? 'after' : 'before'

  const actionDate = docketEntry.action_date ? dateDisplayFormat(docketEntry.action_date) : null
  const eventTimeStart = docketEntry.event_time_start

  const eventDate = actionDate || '(event date not defined yet)'
  const eventDateTime = eventTimeStart ? `${eventDate} ${eventTimeStart}` : eventDate

  return `${Math.abs(interval)} ${unit} ${intervalOccurence} ${eventDateTime}`
}

const automatedTextRecipients = opts => {
  const list = opts.state?.automatedText?.recipients || []
  const phones = opts.rootGetters?.recordPartiesMobileTextingPhonesOptions || []

  const recipients = list.map(recipientId => {
    const party = phones.find(el => el.value === recipientId)
    if (party) return `${party.text} at ${automatedTextPreferredRecipient(party.phones)}`
    else return recipientId
  })
  return `Record parties: ${recipients.join(', ')}`
}

export const AutomatedTextsState = {
  automatedText: {
    message: null,
    recipients: [],
  },
  automatedTextSummary: '',
}

export const AutomatedTextsActions = {
  automatedTextMessageSummary ({ commit, state, rootGetters }) {
    const template = state.docketEntryType?.automated_text_template
    const result = `Send automated text message ${automatedTextSendAt(state.docketEntry, template)} to ${automatedTextRecipients({ state, rootGetters })} with message:`
    commit('setAutomatedTextSummary', result)
  },
  newAutomatedText ({ commit, getters, state }) {
    const automatedText = { message: null, recipients: [] }
    const template = getters.isAutomatedTextEnabled
    if (template) automatedText.message = template.automated_text_message
    if (state.docketEntry?.automated_text) automatedText.recipients = state.docketEntry.automated_text.recipients

    commit('setAutomatedText', automatedText)
  },
  saveAutomatedText: async ({ state, commit }, req) => {
    return axiosRequest.
      put(`/docket_entries/${req.id}/automated_texts`, { automated_text: state.automatedText }).
      then(({ data }) => {
        commit('setAutomatedText', data.automated_text)
      }).
      catch(handleError)
  },
  setAutomatedText ({ commit }, options) {
    commit('setAutomatedText', options)
  },
}

export const AutomatedTextsMutations = {
  setAutomatedText: (state, payload) => { state.automatedText = payload },
  setAutomatedTextSummary: (state, payload) => { state.automatedTextSummary = payload },
}

export const AutomatedTextsGetters = {
  automatedText: state => state.automatedText,
  automatedTextSummary: state => state.automatedTextSummary,
  isAutomatedTextEnabled: state => {
    if (state.docketEntryType) {
      const template = state.docketEntryType.automated_text_template
      if (template && template.allow_automated_text) return template
    }
    return null
  },
}
